import { Divider } from 'antd';
import ProductCardSkeleton from 'catalog/product/components/product-card/card-item.component/skeleton';
import Container from 'common/components/container.component';
import Pulsate from 'common/components/pulsate.component';
import { DeviceTypeList } from 'config/constants/global.constants';
import { useDeviceType } from 'config/hooks/useDeviceType.hook';
import { DeviceType } from 'config/types/common.type';
import CatalogUtils from 'config/utils/catalog.util';
import React from 'react';
import { CSSProperties } from 'styled-components';
import styles from './style.module.scss';

const ProductDetailsSkeleton: React.FC = () => {
  const deviceType: DeviceType = useDeviceType();

  const renderGridSkeleton = (): React.ReactNode => {
    const childs: React.ReactNode[] = [];
    for (let index = 0; index < CatalogUtils.ITEMS_SKELETON_IN_CAROUSEL; index++) {
      childs.push(<ProductCardSkeleton key={index} />);
    }
    return childs;
  };

  const renderGridDesktopThumbnail = (): React.ReactNode[] => {
    const childs: React.ReactNode[] = [];
    for (let index = 0; index < 4; index++) {
      childs.push(<Pulsate width='300px' height='80px' key={index} />);
    }
    return childs;
  };

  const renderGridMobileThumbnail = (): React.ReactNode[] => {
    const childs: React.ReactNode[] = [];
    for (let index = 0; index < 4; index++) {
      childs.push(<Pulsate width='100px' height='70px' key={index} />);
    }
    return childs;
  };

  const skeletonGridStyles: CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(250px, 250px))',
    gap: '15px',
  };

  const renderDesktopSkeleton = (): React.ReactNode => {
    return (
      <React.Fragment>
        <div className={styles['product-details-dektop-top-container']}>
          <div className={styles['product-details-dektop-image-container']}>
            <Pulsate width='100%' height='70%' />
            <div className={styles['thumbnails']}>{renderGridDesktopThumbnail()}</div>
          </div>
          <div className={styles['product-description-container']}>
            <Pulsate width='85%' height='40px' />
            <Pulsate width='20%' height='30px' />
            <Divider />
            <Pulsate width='80%' height='100px' />
            <Pulsate width='30%' height='30px' />
            <Divider />
            <Pulsate width='25%' height='30px' />
            <Pulsate width='30%' height='30px' />
          </div>
        </div>
        <div className={styles['product-details-dektop-bottom-container']}>
          <Pulsate width='30%' height='40px' marginBottom='20px' />
          <div style={skeletonGridStyles}>{renderGridSkeleton()}</div>
        </div>
      </React.Fragment>
    );
  };

  const renderMobileSkeleton = (): React.ReactNode => {
    return (
      <React.Fragment>
        <div className={styles['product-details-mobile-top-container']}>
          <Pulsate width='100%' height='20px' />
          <Pulsate width='50%' height='20px' marginBottom='20px' />
          <div className={styles['product-details-mobile-image-container']}>
            <Pulsate width='100%' height='200px' />
            <div className={styles['thumbnails-mobile']}>{renderGridMobileThumbnail()}</div>
          </div>
          <Pulsate width='100%' height='20px' />
          <Pulsate width='50%' height='20px' />
          <Pulsate width='100%' height='100px' />
        </div>
      </React.Fragment>
    );
  };

  return <Container>{deviceType !== DeviceTypeList.DESKTOP ? renderMobileSkeleton() : renderDesktopSkeleton()}</Container>;
};

export default ProductDetailsSkeleton;
